import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import noimg_img from "@/img/ico/noimg.png";

function CounselInfoArea(props: any) {
  let myProps = {
    select_mcomp_data: {
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    info: {},
    add_memo_info: {},
    set_add_memo_info: (inData: any) => { },
    is_update: false,
    is_view_mode: false,
    refresh_data: () => { },
    Style: {},
    ...props
  };
  let select_mcomp_data = myProps.select_mcomp_data;
  let info = myProps.info;
  let add_memo_info = myProps.add_memo_info;
  let is_view_mode = myProps.is_view_mode;
  let Style = myProps.Style;
  let user = useSelector((state: any) => state.user);

  let default_exam_col_arr=[
    "a_pre_exam_name",
    "a_pre_en_exam_score",
    "a_pre_language_exam_score",
    "a_pre_science_exam_score",
    "a_pre_math_exam_score",
    "a_pre_society_exam_score",
  ];

  const [add_exam_arr, set_add_exam_arr] = useState<any>([]);
  const writeFileForm = useRef<any>(null);
  const fileInput = useRef<any>(null);

  useEffect(() => {
    get_user_add_exam_list_by_ajax();
  }, [info.a_seq]);

  const get_user_add_exam_list_by_ajax = () => {
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let form_json_data = {
      s_stu_seq: info.a_seq,
      "order_id": "a_write_date DESC, a_create_date DESC",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user_add_exam/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_add_exam_arr(response.data["data"]["info_arr"]);
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_add_user_add_exam_by_ajax = () => {
    if (!confirm("직전 시험 석정을 저장하시겠습니까?")) {
      return false;
    }
    let add_exam_row:any = {
      "a_ymd": DateFunc.get_date_format(new Date(), "Ymd"),
      "a_seq": "",
      "a_stu_seq": info.a_seq,
      "a_stu_name": info.a_user_name,
      "a_write_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
      "a_title": "",
    };
    for(let i=0;i<default_exam_col_arr.length;i++){
      let col_name=default_exam_col_arr[i];
      if(add_memo_info[col_name]!=undefined){
        add_exam_row[col_name]=add_memo_info[col_name];
      }
    }
    let form_json_data = {
      "data_arr": [add_exam_row],
      "is_default_val": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user_add_exam/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("저장되었습니다.");
          get_user_add_exam_list_by_ajax();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_delete_user_add_exam_by_ajax = (inData: any) => {
    let opt_obj={
      del_info:null,
      ...inData
    };
    if(opt_obj.del_info==null){
      alert("삭제할 정보가 없습니다.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let form_json_data = {
      "data_arr": [opt_obj.del_info],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user_add_exam/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("삭제되었습니다.");
          get_user_add_exam_list_by_ajax();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const handleInputChange2 = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      ...inData
    };
    let value = opt_obj.value;
    const name = opt_obj.name;
    myProps.set_add_memo_info({
      ...add_memo_info,
      ...{ [name]: value }
    });
  };

  const goCounselfileWrite = (inData: any) => {
    let opt_obj = {
      file_row_data: {},
      ...inData
    };
    let default_file_row_data: any = {
      "a_ymd": DateFunc.get_date_format(new Date(), "Ymd"),
      "a_seq": "",
      "a_comp_seq": user.comp_seq,
      "a_par_id": "user",
      "a_par_seq": info.a_seq,
      "a_sort1": "counsel",
      "a_sort2": "",
      "a_sort3": "",
      "a_writer": user.user_name,
      "a_create_seq": user.user_seq,
    };
    if (!strFunc.is_empty(select_mcomp_data.mcomp_seq)) {
      default_file_row_data["a_comp_seq"] = select_mcomp_data.mcomp_seq;
      default_file_row_data["a_create_seq"] = select_mcomp_data.api_user_seq;
    }
    let file_row_data = {
      ...default_file_row_data,
      ...opt_obj.file_row_data
    };
    if (file_row_data.a_par_seq == "" || file_row_data.a_par_id == "") {
      alert("파일 부모 정보가 올바르지 않습니다.");
      return false;
    }

    if (fileInput.current == null) {
      return false;
    }
    if (writeFileForm.current == null) {
      return false;
    }

    if (fileInput.current.value == "") {
      alert("파일 선택이 필요합니다.");
      return false;
    }

    if (!confirm("상담 사진을 저장 하시겠습니까?")) {
      return false;
    }

    var form = writeFileForm.current;
    var form_json_data = new FormData(form);
    form_json_data.append("data_arr", JSON.stringify([file_row_data]));
    form_json_data.append("authorization", localStorage.intoyou_token);

    my_axios.post(process.env.REACT_APP_FILE_SERVER_URL + '/api/comp/basic/file/file/receive', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.refresh_data();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const goCounselFileDelete = (file_info: any) => {
    if (strFunc.is_empty(file_info)) {
      alert("선택없음.");
      return false;
    }
    let tmp_delete_row = {
      "a_ymd": file_info["a_ymd"],
      "a_seq": file_info["a_seq"],
    };
    if (!confirm("상담 사진을 삭제하시겠습니까?")) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/file/file/delete', {
      data_arr: [tmp_delete_row],
    }, get_axios_data()).then((response) => {
      if (response.data["result"] === "true") {
        alert("삭제되었습니다.");
        //파일안보이게
        myProps.refresh_data();
      } else {
        alert(response.data["msg"]);
      }
    });
  }

  const get_counsel_file_tags = () => {
    if (strFunc.is_empty(info.counsel_file_arr)) {
      return "";
    }
    let counsel_file_tags = info.counsel_file_arr.map((item: any, idx: number) => {
      let thum_img_src = noimg_img;
      if (item["is_image"] == "1") {
        thum_img_src = item["thum_img_url"];
      }
      return (
        <div key={idx} style={{ textAlign: "center" }}>
          <a href={item.img_url} target="_blank" >
            <img src={thum_img_src} style={{ width: "85%" }} />
          </a>
          {is_view_mode == false &&
            <div>
              {item.a_create_date}
              <button className="btn-s btn-red ml-1" onClick={() => {
                goCounselFileDelete(item);
              }}>X</button>
            </div>
          }
        </div>
      );
    });
    return counsel_file_tags;
  };

  const get_exam_list_tags = () => {
    let exam_list_tags = add_exam_arr.map((item: any, idx: number) => {
      return (
        <span key={idx} >
          <span 
            style={{ cursor: "pointer" }}
            onClick={()=>{
              let change_add_memo_info:any={...add_memo_info};
              for(let i=0;i<default_exam_col_arr.length;i++){
                let col_name=default_exam_col_arr[i];
                change_add_memo_info[col_name]=item[col_name];
              }
              myProps.set_add_memo_info(change_add_memo_info);
            }}>
            {idx + 1}. {item.a_pre_exam_name}
            <span style={{color:"#999",fontSize:"10px"}}>({item.a_write_date})</span>
          </span>
          <button className="ml-1 btn-s btn-red"
            onClick={()=>{
              go_delete_user_add_exam_by_ajax({
                del_info:item
              });
            }}>X</button>
        </span>
      );
    });
    return exam_list_tags;
  };

  return (
    <div>
      {myProps.is_update == true &&
        <div style={{ display: "flex", gap: "5px" }}>
          {get_exam_list_tags()}
        </div>
      }
      <div className="write_table_small mt-1">
        <table>
          <colgroup>
            <col width={"5%"}></col>
            <col width={"5%"}></col>
            <col width={"25%"}></col>
            <col width={"5%"}></col>
            <col width={"25%"}></col>
          </colgroup>
          <tbody>
            <tr>
              <th colSpan={2}>
                직전 시험 성적
                <button className="btn btn-circle-yellowish2 ml-2" title="성적 기록하기" onClick={()=>{go_add_user_add_exam_by_ajax();}} >+</button>
              </th>
              <td colSpan={4} style={{ padding: 0, border: 0 }}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        {is_view_mode ?
                          add_memo_info.a_pre_exam_name
                          :
                          <input type="text" className="row-input" value={add_memo_info.a_pre_exam_name}
                            onChange={(e: any) => { handleInputChange2({ name: "a_pre_exam_name", value: e.target.value }); }}
                            placeholder="시험명" />
                        }
                      </td>
                      <th>국어</th>
                      <td>
                        {is_view_mode ?
                          add_memo_info.a_pre_language_exam_score
                          :
                          <input type="text" className="row-input" value={add_memo_info.a_pre_language_exam_score}
                            onChange={(e: any) => { handleInputChange2({ name: "a_pre_language_exam_score", value: e.target.value }); }}
                            placeholder="" />
                        }
                      </td>
                      <th>영어</th>
                      <td>
                        {is_view_mode ?
                          add_memo_info.a_pre_en_exam_score
                          :
                          <input type="text" className="row-input" value={add_memo_info.a_pre_en_exam_score}
                            onChange={(e: any) => { handleInputChange2({ name: "a_pre_en_exam_score", value: e.target.value }); }}
                            placeholder="" />
                        }
                      </td>
                      <th>수학</th>
                      <td>
                        {is_view_mode ?
                          add_memo_info.a_pre_math_exam_score
                          :
                          <input type="text" className="row-input" value={add_memo_info.a_pre_math_exam_score}
                            onChange={(e: any) => { handleInputChange2({ name: "a_pre_math_exam_score", value: e.target.value }); }}
                            placeholder="" />
                        }
                      </td>
                      <th>사회</th>
                      <td>
                        {is_view_mode ?
                          add_memo_info.a_pre_society_exam_score
                          :
                          <input type="text" className="row-input" value={add_memo_info.a_pre_society_exam_score}
                            onChange={(e: any) => { handleInputChange2({ name: "a_pre_society_exam_score", value: e.target.value }); }}
                            placeholder="" />
                        }
                      </td>
                      <th>과학</th>
                      <td>
                        {is_view_mode ?
                          add_memo_info.a_pre_science_exam_score
                          :
                          <input type="text" className="row-input" value={add_memo_info.a_pre_science_exam_score}
                            onChange={(e: any) => { handleInputChange2({ name: "a_pre_science_exam_score", value: e.target.value }); }}
                            placeholder="" />
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th colSpan={2}>이전학습 이력</th>
              <td colSpan={3} style={{ paddingBottom: 1 }} >
                {is_view_mode ?
                  <MultyLineTextView text={add_memo_info.a_pre_edu_history}></MultyLineTextView>
                  :
                  <TextAreaComponent
                    name={"a_pre_edu_history"}
                    value={add_memo_info.a_pre_edu_history}
                    class_name={"row-input"}
                    height={32}
                    style={{ "width": "100%" }}
                    onChange={(e: any) => {
                      handleInputChange2({
                        name: "a_pre_edu_history",
                        value: e.target.value,
                      });
                    }}
                  ></TextAreaComponent>
                }
              </td>
            </tr>
            <tr>
              <th colSpan={2}>난제 상황</th>
              <td colSpan={3} style={{ paddingBottom: 1 }} >
                {is_view_mode ?
                  <MultyLineTextView text={add_memo_info.a_matter_condition}></MultyLineTextView>
                  :
                  <TextAreaComponent
                    name={"a_matter_condition"}
                    value={add_memo_info.a_matter_condition}
                    height={32}
                    onChange={(e: any) => {
                      handleInputChange2({
                        name: "a_matter_condition",
                        value: e.target.value,
                      });
                    }}
                  ></TextAreaComponent>
                }
              </td>
            </tr>
            <tr>
              <th colSpan={2}>상담 내용</th>
              <td colSpan={3} style={{ paddingBottom: 1 }} >
                {is_view_mode ?
                  <MultyLineTextView text={add_memo_info.a_counsel_content}></MultyLineTextView>
                  :
                  <TextAreaComponent
                    name={"a_counsel_content"}
                    value={add_memo_info.a_counsel_content}
                    height={32}
                    onChange={(e: any) => {
                      handleInputChange2({
                        name: "a_counsel_content",
                        value: e.target.value,
                      });
                    }}
                  ></TextAreaComponent>
                }
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>
                상담  시<br />
                주 호소 내용
              </th>
              <th>학생</th>
              <td colSpan={3} style={{ paddingBottom: 1 }} >
                {is_view_mode ?
                  <MultyLineTextView text={add_memo_info.a_appeal_from_student}></MultyLineTextView>
                  :
                  <TextAreaComponent
                    name={"a_appeal_from_student"}
                    value={add_memo_info.a_appeal_from_student}
                    height={32}
                    onChange={(e: any) => {
                      handleInputChange2({
                        name: "a_appeal_from_student",
                        value: e.target.value,
                      });
                    }}
                  ></TextAreaComponent>
                }
              </td>
            </tr>
            <tr>
              <th>학부모</th>
              <td colSpan={3} style={{ paddingBottom: 1 }} >
                {is_view_mode ?
                  <MultyLineTextView text={add_memo_info.a_appeal_from_parent}></MultyLineTextView>
                  :
                  <TextAreaComponent
                    name={"a_appeal_from_parent"}
                    value={add_memo_info.a_appeal_from_parent}
                    height={32}
                    onChange={(e: any) => {
                      handleInputChange2({
                        name: "a_appeal_from_parent",
                        value: e.target.value,
                      });
                    }}
                  ></TextAreaComponent>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default CounselInfoArea;